import type { ISession } from '../interface/session';
import type { ISessionData } from '../private/db';

function captureState(session: ISession): ISessionData {
    return {
        name: session.name,
        userState: session.state.flatten(),
        auth: session.auth.serialize(),
    };
}

function isSessionData(object: unknown): object is ISessionData {
    const isNullOrUndefined = (value: unknown): boolean => value === null || value === undefined;

    if (isNullOrUndefined(object) || typeof object !== 'object') {
        return false;
    }

    const record: Partial<ISessionData> = object as Partial<ISessionData>;

    return (
        !isNullOrUndefined(record.name) &&
        !isNullOrUndefined(record.userState) &&
        !isNullOrUndefined(record.auth)
    );
}

function flatten(session: ISession): string {
    return JSON.stringify(captureState(session));
}

function expand(data: string): ISessionData {
    const obj = JSON.parse(data);

    if (!isSessionData(obj)) {
        throw new Error(`Invalid object, not ISessionData: ${JSON.stringify(obj)}`);
    }

    return obj;
}

export default Object.freeze({
    captureState,
    isSessionData,
    expand,
    flatten,
});
